const toggleFullListButtonsAll = document.querySelectorAll("._jsToggleFullList");

toggleFullListButtonsAll.forEach(toggleFullListButton => {

	const thisList = toggleFullListButton.closest("li").querySelector("ul");
	const numberOfItemsInThisList = thisList.querySelectorAll("li").length;

	// hide button if few items in list
	if (numberOfItemsInThisList < 3) {
		toggleFullListButton.setAttribute("hidden", "");
	}
	// add aria attribute to list if it has hidden items
	else {
		thisList.setAttribute("aria-live", "polite");
	}

	// toggle full list on click
	toggleFullListButton.addEventListener("click", function() {
		if (this.getAttribute("aria-expanded") === "true") {
			thisList.classList.remove("open");
			this.setAttribute("aria-expanded", "false");
		}
		else {
			thisList.classList.add("open");
			this.setAttribute("aria-expanded", "true");
		}
	});
});